import { render, staticRenderFns } from "./CartSummaryPerpetualUpgrade.vue?vue&type=template&id=2c946520&"
import script from "./CartSummaryPerpetualUpgrade.vue?vue&type=script&lang=js&"
export * from "./CartSummaryPerpetualUpgrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\websites\\newshop\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c946520')) {
      api.createRecord('2c946520', component.options)
    } else {
      api.reload('2c946520', component.options)
    }
    module.hot.accept("./CartSummaryPerpetualUpgrade.vue?vue&type=template&id=2c946520&", function () {
      api.rerender('2c946520', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/CartSummary/CartSummaryPerpetualUpgrade.vue"
export default component.exports